import { isAxiosError } from 'axios';
import { ErrorCode } from '../types.js';
import { isVrioOttError } from '../isVrioOttError.js';

function createErrorInterceptor(errorFactory, options) {
  return async (error) => {
    if (isVrioOttError(error)) {
      throw error;
    }
    if (isAxiosError(error)) {
      throw errorFactory.createFromAxiosError(error, {
        source: options.source,
        externCode: error.response && options.getExternCode(error.response),
        getResponseMessage: options.getResponseMessage
      });
    }
    throw errorFactory.ensureVrioOttError(error, {
      source: options.source,
      code: ErrorCode.UNEXPECTED_ERROR
    });
  };
}

export { createErrorInterceptor };
//# sourceMappingURL=interceptor.js.map
